export const checkHasPeriodPassed = ({
  endDate = '',
}: {
  endDate?: string
}) => {
  const now = new Date()
  const endOfCampaignDate = new Date(endDate)
  return now > endOfCampaignDate
}
